'use client'

import type { ReactNode } from 'react'
import { usePathname } from '@/lib/react-compat/navigation'
import { Header } from '@/components/header'
import { Footer } from '@/components/footer'

export default function SiteLayout({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  const hideChrome = pathname === '/login'

  return (
    <div className="flex min-h-screen flex-col">
      {!hideChrome && <Header />}
      <main className="flex-1">{children}</main>
      {!hideChrome && <Footer />}
    </div>
  )
}
